export default "__VITE_ASSET__AWQmqzPK__"